module.exports = __webpack_public_path__ + "static/metasploit-ef8ebfbb107284c630cc8c2422a65beb.svg";